import React from 'react';
import { portfolioData } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-32 bg-black relative overflow-hidden border-t border-zinc-900">
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-20 items-start">
          {/* Left: Content */}
          <div>
            <span className="text-sm tracking-[0.3em] text-zinc-500 uppercase font-medium mb-4 block">
              About
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-white tracking-tight mb-8">
              Crafting Stories
            </h2>
            
            <div className="space-y-6 text-lg text-zinc-400 leading-relaxed mb-12">
              <p>
                {portfolioData.bio}
              </p>
              <p>
                I specialize in transforming raw footage into compelling narratives that resonate with audiences. 
                From concept to final cut, I bring a cinematic approach to every project.
              </p>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-8 mb-12">
              <div>
                <div className="text-5xl font-black text-white mb-2">5+</div>
                <div className="text-sm text-zinc-500 uppercase tracking-wider">Years</div>
              </div>
              <div>
                <div className="text-5xl font-black text-white mb-2">100+</div>
                <div className="text-sm text-zinc-500 uppercase tracking-wider">Projects</div>
              </div>
              <div>
                <div className="text-5xl font-black text-white mb-2">50+</div>
                <div className="text-sm text-zinc-500 uppercase tracking-wider">Clients</div>
              </div>
            </div>

            {/* Experience Timeline */}
            <div className="space-y-8">
              <h3 className="text-2xl font-bold text-white mb-6">Experience</h3>
              {portfolioData.experience.map((exp, index) => (
                <div
                  key={exp.id}
                  className="border-l-2 border-zinc-800 pl-6 pb-2"
                  style={{
                    animation: `fade-in-right 0.6s ease-out ${index * 0.15}s both`
                  }}
                >
                  <div className="text-sm text-cyan-400 font-medium mb-1">{exp.period}</div>
                  <h4 className="text-xl font-bold text-white mb-1">{exp.title}</h4>
                  <div className="text-zinc-500 font-medium mb-3">{exp.company}</div>
                  <ul className="space-y-2">
                    {exp.bullets.map((bullet, i) => (
                      <li key={i} className="text-sm text-zinc-500 leading-relaxed flex gap-2">
                        <span className="text-cyan-400 mt-1 flex-shrink-0">•</span>
                        <span>{bullet}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Large Image */}
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden bg-zinc-900">
              <img
                src="https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?w=800&h=1000&fit=crop"
                alt="Video Editing Setup"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
